import { HTTP_METHODS } from 'do-front-end-utils';
import { sendRequestToDhwanoServiceWithCredentials } from '../../utils/request';

/**
 * Get the cocaller backend's app settings / feature capabilities
 * @description This function is used to fetch the recruiter-scoped app settings
 * @returns The app settings
 */
export const getCocallerAppSettingsApi = () =>
  sendRequestToDhwanoServiceWithCredentials({
    method: HTTP_METHODS.GET,
    url: '/core/app-settings/',
  });
